var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-button",class:_vm.classes,on:{"click":_vm.clicked}},[_c('div',{staticClass:"circle"},[_c('b-icon',{attrs:{"icon":_vm.buttonStyle.icon}})],1),_c('div',{staticClass:"text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.buttonStyle.text))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }